import {validateField, clearFields, setFieldOptions} from './helpers/form'
import {
  SET_VOICE_TEST_CRITERIA_DROPDOWN_OPTIONS,
  VALIDATE_VOICE_TEST_CRITERIA_ADAPTOR_FIELD,
  CLEAR_VOICE_TEST_CRITERIA_ADAPTOR_FIELDS
} from '../../../actions/pages/voice-test-page'

export function voiceTestCriteriaAdaptor (
  state = {
    valid: false,
    fields: [
      {
        name: 'SkillLevel',
        value: '',
        errors: [],
        rules: {
          title: 'Rating'
        },
        placeholder: 'Any level',
        options: []
      },
      {
        name: 'City',
        value: '',
        errors: [],
        rules: {
          title: 'City'
        },
        placeholder: 'Any city',
        options: []
      },
      {
        name: 'NativeLanguage',
        value: '',
        errors: [],
        rules: {
          title: 'Native language'
        },
        placeholder: 'Any language',
        options: []
      },
      {
        name: 'AdditionalLanguage',
        value: '',
        errors: [],
        rules: {
          title: 'Experience'
        },
        placeholder: 'Any language',
        options: []
      },
      {
        name: 'ProductionContentOwner',
        value: '',
        errors: [],
        rules: {
          title: 'Client experience'
        },
        placeholder: 'Any',
        options: []
      },
      {
        name: 'ProductionExperience',
        value: '',
        errors: [],
        rules: {
          title: 'Production experience'
        },
        placeholder: 'Any',
        options: []
      }
    ]
  },
  action
) {
  switch (action.type) {
    case SET_VOICE_TEST_CRITERIA_DROPDOWN_OPTIONS: {
      var newState = setFieldOptions(state, 'SkillLevel', action.skillLevels);
      newState = setFieldOptions(newState, 'City', action.cities);
      newState = setFieldOptions(newState, 'NativeLanguage', action.nativeLanguages);
      newState = setFieldOptions(newState, 'AdditionalLanguage', action.languages);
      newState = setFieldOptions(newState, 'ProductionContentOwner', action.productionContentOwners);
      return setFieldOptions(newState, 'ProductionExperience', action.productionExperienceList);
    }

    case VALIDATE_VOICE_TEST_CRITERIA_ADAPTOR_FIELD: {
      return validateField(state, action);
    }

    case CLEAR_VOICE_TEST_CRITERIA_ADAPTOR_FIELDS: {
      return clearFields(state);
    }

    default:
      return state
  }
}
